<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Starter page component
 */
export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Starter page",
            items: [
                {
                    text: "Utility",
                    href: "/",
                },
                {
                    text: "Starter page",
                    active: true,
                },
            ],
            loading: false,
            appid: "",
            userinfo: [],
            chargeactive: [],
            recharge: {
                is_entrance: 0,
                is_custom: 0,
                describe: "",
            },
        };
    },
    mounted() {
        try {
            this.userinfo = JSON.parse(localStorage.getItem("user") || "null") || {};
        } catch (e) {
            this.userinfo = {};
        }
        this.appid = this.$route.params.appid;
        this.title = "充值设置";
        this.items = [
            {
                text: this.$t("menuitems.micoapp.text"),
                href: "/",
            },
            {
                text: this.$t("menuitems.icp.micoapp.list"),
                href: "/micoapp",
            },
            {
                text: this.$t("menuitems.icp.micoapp.info"),
                href: `/micoapp/${this.appid}`,
            },
            {
                text: "充值设置",
                active: true,
            },
        ];
        this.getmicoappmenu();
    },
    methods: {
        defaultRecharge() {
            return {
                is_entrance: 0,
                is_custom: 0,
                describe: "",
            };
        },
        /** 安全解析设置字段：空值/非法 JSON 时回退默认值 */
        parseSetting(raw, fallback) {
            if (raw == null || raw === "") {
                return typeof fallback === "function" ? fallback() : fallback;
            }
            if (typeof raw === "object") {
                return raw;
            }
            try {
                const parsed = JSON.parse(raw);
                if (parsed == null || parsed === "") {
                    return typeof fallback === "function" ? fallback() : fallback;
                }
                return parsed;
            } catch (e) {
                return typeof fallback === "function" ? fallback() : fallback;
            }
        },
        getmicoappmenu() {
            var that = this;
            that.loading = true;
            that.$axios
                .post(
                    "https://api.aicoiot.com/micoappapi.php",
                    {
                        action: "micoapp.setting",
                        appid: that.$route.params.appid,
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    that.loading = false;
                    const data =
                        response.data && response.data.data ? response.data.data : {};
                    that.chargeactive = that.parseSetting(data.chargeactive, []);
                    if (!Array.isArray(that.chargeactive)) {
                        that.chargeactive = [];
                    }
                    const recharge = that.parseSetting(
                        data.recharge,
                        that.defaultRecharge
                    );
                    that.recharge = Object.assign(that.defaultRecharge(), recharge || {});
                    that.recharge.is_entrance = Number(that.recharge.is_entrance) || 0;
                    that.recharge.is_custom = Number(that.recharge.is_custom) || 0;
                    if (that.recharge.describe == null) {
                        that.recharge.describe = "";
                    }
                })
                .catch(function (error) {
                    that.loading = false;
                    that.chargeactive = [];
                    that.recharge = that.defaultRecharge();
                    that.$notify.error({
                        title: "请求错误",
                        message: (error && error.message) || String(error),
                    });
                });
        },
        save_micoappsetting(type) {
            var that = this;
            let postdata = that[type];
            that.loading = true;
            if (postdata) {
                that.$axios
                    .post(
                        "https://api.aicoiot.com/micoappapi.php",
                        {
                            action: "micoapp.savesetting",
                            appid: that.$route.params.appid,
                            type: type,
                            datas: postdata
                        },
                        {
                            headers: { Openid: that.userinfo.openid },
                        }
                    )
                    .then(function (response) {
                        that.loading = false;
                        if (response.data.status == 200) {
                            that.$message.success({
                                message: "保存成功"
                            });
                            that.getmicoappmenu();
                        } else {
                            that.$message.error({
                                message: response.data.message
                            });
                        }
                    })
                    .catch(function (error) {
                        that.loading = false;
                        that.$notify.error({
                            title: "请求错误",
                            message: (error && error.message) || String(error),
                        });
                    });

            } else {
                that.$message.error({
                    message: "提交数据不存在"
                });
            }
        }
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="micoapp-page">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body" v-loading="loading">
                        <div class="micoapp-toolbar">
                            <div class="micoapp-toolbar-title">
                                <h5>充值设置</h5>
                                <p>配置充值入口、说明与自定义金额</p>
                            </div>
                        </div>
                        <el-form ref="form" :model="recharge" label-width="90px" class="micoapp-form">
                            <el-form-item label="充值开关">
                                <el-switch v-model="recharge.is_entrance" active-text="开启" inactive-text="关闭"
                                    :active-value="1" :inactive-value="0">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="自定义金额">
                                <el-switch v-model="recharge.is_custom" active-text="开启" inactive-text="关闭"
                                    :active-value="1" :inactive-value="0">
                                </el-switch>
                            </el-form-item>
                            <el-form-item label="充值说明">
                                <el-input type="textarea" :rows="4" v-model="recharge.describe"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="save_micoappsetting('recharge')" type="primary">保存</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </Layout>
</template>
